/**
* given an object of query parameters, returns a query string in the format "field1=value1&field2=value2&..."
* @param  {Object} obj object of query parameters
* @return {String}     query parameters string
*/
export default function objToQueryString(obj) {
  const strings = []; //create an empty array

  if(typeof obj === "object") {
    //for each key
    Object.keys(obj).forEach(key => {
      strings.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])); //encode the key and value pair
    })
  }

  return strings.join("&"); //join the array with the & symbol
}
